/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer to create a MobileDevice.
 * @export
 * @interface CreateMobileDeviceRequest
 */
export interface CreateMobileDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMobileDeviceRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMobileDeviceRequest
     */
    deviceName: string;
    /**
     * 
     * @type {any}
     * @memberof CreateMobileDeviceRequest
     */
    publicKey: any | null;
    /**
     * 
     * @type {string}
     * @memberof CreateMobileDeviceRequest
     */
    tempToken?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMobileDeviceRequest
     */
    codeVerifier?: string;
}

/**
 * Check if a given object implements the CreateMobileDeviceRequest interface.
 */
export function instanceOfCreateMobileDeviceRequest(value: object): value is CreateMobileDeviceRequest {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if ((!('deviceName' in (value as Record<string, any>)) && !('device_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceName'] === undefined && (value as Record<string, any>)['device_name'] === undefined)) return false;
    if ((!('publicKey' in (value as Record<string, any>)) && !('public_key' in (value as Record<string, any>))) || ((value as Record<string, any>)['publicKey'] === undefined && (value as Record<string, any>)['public_key'] === undefined)) return false;
    return true;
}

export function CreateMobileDeviceRequestFromJSON(json: any): CreateMobileDeviceRequest {
    return CreateMobileDeviceRequestFromJSONTyped(json, false);
}

export function CreateMobileDeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMobileDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
        'deviceName': json['device_name'],
        'publicKey': json['public_key'],
        'tempToken': json['temp_token'] == null ? undefined : json['temp_token'],
        'codeVerifier': json['code_verifier'] == null ? undefined : json['code_verifier'],
    };
}

export function CreateMobileDeviceRequestToJSON(json: any): CreateMobileDeviceRequest {
    return CreateMobileDeviceRequestToJSONTyped(json, false);
}

export function CreateMobileDeviceRequestToJSONTyped(value?: CreateMobileDeviceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'device_name': value['deviceName'],
        'public_key': value['publicKey'],
        'temp_token': value['tempToken'],
        'code_verifier': value['codeVerifier'],
    };
}

